import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import _memoize from 'lodash/memoize';
import { cacheResolver, makeDefaultStylingContext } from '../utils/style';
import { TRANSPARENT } from '../utils/colors';
import {
  BORDER_COLOR,
  BORDER_RADIUS,
  BORDER_WIDTH,
  INNER_BORDER_COLOR,
  SCALE_FOCUSED,
  FOCUSED_BORDER_ALPHA,
  UNFOCUSED_BORDER_ALPHA,
} from '../utils/focus';
import { ICONS, sizes, templates } from './jacket.constants';
import { middle } from '../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const ICON_PADDING_VERTICAL = 4;

export const ICON_PADDING_HORIZONTAL = 8;

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const LOCK_ICON_HEIGHT = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const PADDING_VERTICAL = 4;

export const PADDING_HORIZONTAL = 8;

export const getIconViewBox = _memoize(screenSize => ({
  h: ICON_HEIGHT[screenSize],
}));

export const getIcon = (icons, position) => (icons ? icons[ICONS[position]] : null);

export const getInitialStyle = ({ screenSize } = defaultContext) => {
  const { w, h } = sizes[templates.Jacket][RENDERING_CONTEXT.GENERAL][screenSize];
  const borderSize = BORDER_WIDTH[screenSize];
  const borderOffset = borderSize * 2;

  return {
    Border: {
      alpha: 0,
      w: w + borderOffset,
      h: h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: TRANSPARENT,
      shader: {
        radius: BORDER_RADIUS[screenSize],
        outline: BORDER_WIDTH[screenSize],
        strokeColor: TRANSPARENT,
        innerColor: TRANSPARENT,
      },
    },
    Image: {
      ...sizes[screenSize],
      shader: {
        radius: BORDER_RADIUS[screenSize],
      },
    },
    TopLeftIcon: {
      x: PADDING_HORIZONTAL,
      y: PADDING_VERTICAL,
    },
    TopRightIcon: {
      alpha: 0.8,
      x: w - PADDING_HORIZONTAL - ICON_HEIGHT[screenSize],
      y: h - PADDING_VERTICAL - ICON_HEIGHT[screenSize],
    },
    BottomRightIcon: {
      mountX: 1,
      x: w - PADDING_HORIZONTAL,
      y: PADDING_VERTICAL,
    },
    Incentive: {
      x: middle,
      y: middle,
      mount: 0.5,
    },
  };
};

export const getFocusedStyle = _memoize(
  ({ colorMode }) => ({
    Border: {
      smooth: {
        alpha: FOCUSED_BORDER_ALPHA,
        scale: SCALE_FOCUSED,
        'shader.strokeColor': BORDER_COLOR[colorMode],
        'shader.innerColor': INNER_BORDER_COLOR[colorMode],
        'shader.scale': SCALE_FOCUSED,
      },
    },
    Image: {
      smooth: {
        scale: SCALE_FOCUSED,
        'shader.scale': SCALE_FOCUSED,
      },
    },
  }),
  cacheResolver,
);

export const unFocusedStyle = {
  Border: {
    smooth: {
      alpha: UNFOCUSED_BORDER_ALPHA,
      scale: 1,
      'shader.strokeColor': TRANSPARENT,
      'shader.innerColor': TRANSPARENT,
      'shader.scale': 1.0,
    },
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0,
    },
  },
};
